'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _delay = require('lodash/delay');var _delay2 = _interopRequireDefault(_delay);
var _beautifyNumber = require('../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);
var _clearNumber = require('../../helpers/clearNumber');var _clearNumber2 = _interopRequireDefault(_clearNumber);
var _constants = require('../../constants');
var _PropertiesCounter = require('./PropertiesCounter.scss');var styles = _interopRequireWildcard(_PropertiesCounter);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

PropertiesCounter = function (_Component) {_inherits(PropertiesCounter, _Component);function PropertiesCounter() {var _temp, _this, _ret;_classCallCheck(this, PropertiesCounter);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);}PropertiesCounter.prototype.


  componentWillUnmount = function componentWillUnmount() {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
  };PropertiesCounter.prototype.



























































  render = function render() {var _this2 = this;
    return (
      _react2.default.createElement('div', {
          className: (0, _classnames2.default)(styles.propertiesCounter, this.props.className),
          ref: function ref(_ref) {_this2.propertiesCounter = _ref;} },

        this.renderContent()));


  };return PropertiesCounter;}(_react.Component);PropertiesCounter.formatMessage = function () {var template = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];return template.replace(/%s/g, args.shift.bind(args));};var _initialiseProps = function _initialiseProps() {var _this3 = this;this.showContentTimer = function () {_this3.propertiesCounter.style.display = 'block';if (_this3.timerId) {clearTimeout(_this3.timerId);}_this3.timerId = (0, _delay2.default)(function () {_this3.propertiesCounter.style.display = 'none';_this3.timerId = null;}, _constants.countOfPropertiesShowTime);};this.textFormatter = function () {var _props = _this3.props,translate = _props.translate,visibleProperties = _props.visibleProperties,totalProperties = _props.totalProperties;var templateArgs = [visibleProperties, totalProperties].map(function (number) {return (0, _beautifyNumber2.default)((0, _clearNumber2.default)(number || 0));});var template = void 0;if (visibleProperties === 0 && totalProperties === 0 || !totalProperties && !visibleProperties || visibleProperties === 0 && totalProperties) {template = translate('noResults')();} else if (visibleProperties < totalProperties) {template = translate('overflowTemplate')();} else {template = translate('normalTemplate')();}return PropertiesCounter.formatMessage(template, templateArgs);};this.renderAdditionalContent = function () {return _this3.props.shouldRenderActionText && _react2.default.createElement('span', { className: styles.actionText, onClick: _this3.props.actionHandler }, _this3.props.actionText);};this.renderContent = function () {var _props2 = _this3.props,loading = _props2.loading,translate = _props2.translate;if (loading) {return _react2.default.createElement('span', { className: styles.loading }, _react2.default.createElement('span', null, _react2.default.createElement('i', { className: 'icon icon-om-spinner om-pulse' })), '\xA0\xA0', _react2.default.createElement('span', null, translate('loading')()));}var separator = _this3.props.shouldRenderActionText ? ', ' : '';return _react2.default.createElement('span', null, _this3.textFormatter(), separator, _this3.renderAdditionalContent());};};exports.default = PropertiesCounter;


PropertiesCounter.propTypes = {
  className: _propTypes2.default.string,
  totalProperties: _propTypes2.default.number,
  visibleProperties: _propTypes2.default.number,
  loading: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  actionText: _propTypes2.default.func,
  actionHandler: _propTypes2.default.func,
  shouldRenderActionText: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertiesCounter/PropertiesCounter.js
// module id = 2839
// module chunks = 0